import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

export const FilterShape = ({
  fillColor = 'none',
  height = 22,
  width = 22,
  style
}: BaseSVGType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill={fillColor}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M8.25 11C8.25276 10.6904 8.21266 10.3819 8.13083 10.0833H19.25C19.4931 10.0833 19.7263 10.1799 19.8982 10.3518C20.0701 10.5237 20.1667 10.7569 20.1667 11C20.1667 11.2431 20.0701 11.4763 19.8982 11.6482C19.7263 11.8201 19.4931 11.9167 19.25 11.9167H8.13083C8.21266 11.6181 8.25276 11.3096 8.25 11Z"
        fill="#303031"
      />
      <path
        d="M14.6667 4.58333C14.6694 4.27374 14.6293 3.96526 14.5475 3.66667H19.25C19.4931 3.66667 19.7263 3.76324 19.8982 3.93515C20.0701 4.10706 20.1667 4.34022 20.1667 4.58333C20.1667 4.82645 20.0701 5.05961 19.8982 5.23152C19.7263 5.40342 19.4931 5.5 19.25 5.5H14.5475C14.6293 5.20141 14.6694 4.89292 14.6667 4.58333Z"
        fill="#303031"
      />
      <path
        d="M2.75001 3.66667H7.45251C7.29357 4.26744 7.29357 4.89922 7.45251 5.5H2.75001C2.5069 5.5 2.27374 5.40342 2.10183 5.23152C1.92992 5.05961 1.83334 4.82645 1.83334 4.58333C1.83334 4.34022 1.92992 4.10706 2.10183 3.93515C2.27374 3.76324 2.5069 3.66667 2.75001 3.66667Z"
        fill="#303031"
      />
      <path
        d="M2.75001 16.5H13.8692C13.7873 16.7986 13.7472 17.1071 13.75 17.4167C13.7472 17.7263 13.7873 18.0347 13.8692 18.3333H2.75001C2.5069 18.3333 2.27374 18.2368 2.10183 18.0648C1.92992 17.8929 1.83334 17.6598 1.83334 17.4167C1.83334 17.1735 1.92992 16.9404 2.10183 16.7685C2.27374 16.5966 2.5069 16.5 2.75001 16.5Z"
        fill="#303031"
      />
      <path
        d="M17.4167 14.6667C17.9212 14.6652 18.4163 14.8026 18.848 15.0638C19.2796 15.3249 19.6311 15.6998 19.8639 16.1473C20.0968 16.5949 20.202 17.0978 20.1682 17.6012C20.1343 18.1045 19.9627 18.5889 19.672 19.0012C19.3813 19.4135 18.9828 19.7379 18.5201 19.939C18.0574 20.14 17.5483 20.2098 17.0485 20.1408C16.5487 20.0719 16.0776 19.8668 15.6866 19.548C15.2956 19.2292 14.9998 18.809 14.8317 18.3333C14.6119 17.742 14.6119 17.0913 14.8317 16.5C15.0208 15.9651 15.3707 15.5017 15.8335 15.1735C16.2963 14.8453 16.8493 14.6683 17.4167 14.6667Z"
        fill="#303031"
      />
      <path
        d="M4.58334 8.24999C5.15071 8.25159 5.7037 8.42863 6.16649 8.75685C6.62928 9.08508 6.97922 9.54841 7.16834 10.0833C7.38816 10.6747 7.38816 11.3253 7.16834 11.9167C7.00018 12.3923 6.70441 12.8125 6.31342 13.1313C5.92243 13.4501 5.45127 13.6552 4.95151 13.7242C4.45176 13.7931 3.94266 13.7233 3.47994 13.5223C3.01723 13.3213 2.61872 12.9969 2.32803 12.5845C2.03734 12.1722 1.86568 11.6879 1.83182 11.1845C1.79797 10.6812 1.90323 10.1782 2.13609 9.73066C2.36895 9.28313 2.72043 8.90827 3.15206 8.64712C3.5837 8.38596 4.07886 8.24858 4.58334 8.24999Z"
        fill="#303031"
      />
      <path
        d="M11 1.83333C11.5674 1.83493 12.1203 2.01197 12.5831 2.34019C13.0459 2.66841 13.3959 3.13174 13.585 3.66666C13.8048 4.25801 13.8048 4.90865 13.585 5.5C13.3923 6.03089 13.0408 6.48958 12.5783 6.81373C12.1158 7.13788 11.5648 7.31177 11 7.31177C10.4352 7.31177 9.88413 7.13788 9.42164 6.81373C8.95914 6.48958 8.60767 6.03089 8.41499 5.5C8.19517 4.90865 8.19517 4.25801 8.41499 3.66666C8.60411 3.13174 8.95405 2.66841 9.41684 2.34019C9.87963 2.01197 10.4326 1.83493 11 1.83333Z"
        fill="#303031"
      />
    </svg>
  );
};